import React, { useState } from 'react';
import { useStore } from 'effector-react';
import { type HSIconPolygon, HSIconType } from '@types';
import Tabbar from '@components/Tabbar';
import ColorPicker from '@components/ColorPicker';
import Slider from '@components/Slider';
import colorStringToHexAndAlpha from '@utils/colorStringToHexAndAlpha';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import { hotspotIconDefault } from '../../../../hotspot';

const defaultData = hotspotIconDefault({
  type: HSIconType.polygon,
}) as HSIconPolygon;

function PolygonColorSetting() {
  const { hotspot } = useStore($editingHotspot)!;
  const player = MainPlayer.get();
  const icon = hotspot.icon as HSIconPolygon;
  const [tab, setTab] = useState(0);

  const width = tab === 1 ? icon.overBorderWidth : icon.borderWidth;

  const handleColorChange = (str: string) => {
    const { hex, alpha } = colorStringToHexAndAlpha(str);
    if (tab === 1) {
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconPolygon).overFillColor = str;
      });
      player?.updatePolygonHotspot({
        id: hotspot.id,
        overFillColor: hex,
        overFillAlpha: alpha,
      });
    } else {
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconPolygon).fillColor = str;
      });
      player?.updatePolygonHotspot({
        id: hotspot.id,
        fillColor: hex,
        fillAlpha: alpha,
      });
    }
  };

  const handleBorderColorChange = (str: string) => {
    const { hex, alpha } = colorStringToHexAndAlpha(str);
    if (tab === 1) {
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconPolygon).overBorderColor = str;
      });
      player?.updatePolygonHotspot({
        id: hotspot.id,
        overBorderColor: hex,
        overBorderAlpha: alpha,
      });
    } else {
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconPolygon).borderColor = str;
      });
      player?.updatePolygonHotspot({
        id: hotspot.id,
        borderColor: hex,
        borderAlpha: alpha,
      });
    }
  };

  const handleWidthChange = (val: number) => {
    if (tab === 1) {
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconPolygon).overBorderWidth = val;
      });
      player?.updatePolygonHotspot({ id: hotspot.id, overBorderWidth: val });
    } else {
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconPolygon).borderWidth = val;
      });
      player?.updatePolygonHotspot({ id: hotspot.id, borderWidth: val });
    }
  };

  return (
    <>
      <Tabbar
        tabs={['默认状态', '移入状态']}
        activeIndex={tab}
        onChange={setTab}
      />
      <ColorPicker
        className="mt-20"
        colorString={tab === 1 ? icon.overFillColor : icon.fillColor}
        onChange={handleColorChange}
      >
        <ColorPicker.Header>
          <div>填充颜色：</div>
          <ColorPicker.Reset
            defaultColor={
              tab === 1 ? defaultData.overFillColor : defaultData.fillColor
            }
          />
        </ColorPicker.Header>
        <ColorPicker.Bar />
      </ColorPicker>
      <ColorPicker
        className="mt-20"
        colorString={tab === 1 ? icon.overBorderColor : icon.borderColor}
        onChange={handleBorderColorChange}
      >
        <ColorPicker.Header>
          <div>边框颜色：</div>
          <ColorPicker.Reset
            defaultColor={
              tab === 1 ? defaultData.overBorderColor : defaultData.borderColor
            }
          />
        </ColorPicker.Header>
        <ColorPicker.Bar />
      </ColorPicker>
      <Slider
        className="mt-20"
        min={0}
        max={100}
        value={width}
        valToString={(val) => `${val}px`}
        onChange={handleWidthChange}
      >
        <Slider.Header title="边框粗细：" />
        <Slider.Bar />
        <Slider.Footer />
      </Slider>
    </>
  );
}

export default PolygonColorSetting;
